import { render } from "./Renz.vue?vue&type=template&id=75614d1e&scoped=true"
import script from "./Renz.vue?vue&type=script&lang=js"
export * from "./Renz.vue?vue&type=script&lang=js"

import "./Renz.vue?vue&type=style&index=0&id=75614d1e&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75614d1e"]])

export default __exports__